import React from 'react';
import { IOrderProduct, IOrderProductModifier } from 'src/types/orders';
import { OrderOption } from '../OrderOption/OrderOption';
import './style.scss';

interface IProps {
  modifier: IOrderProductModifier;
  productQuantity: IOrderProduct['quantity'];
}

export const OrderModifier = ({ modifier, productQuantity }: IProps) => {
  return (
    <>
      {modifier.options.map((option) => (
        <OrderOption option={option} productQuantity={productQuantity} />
      ))}
    </>
  );
};
